import React from "react";
import MegaMenuLink from "./MegaMenuLink";
import { ArrowUpRightIcon } from "../icons";
import { getMegaMenuMeta, groupChildrenByCategory } from "./megaMenuUtils";

const MegaMenuMobilePanel = ({ navItem }) => {
  const meta = getMegaMenuMeta(navItem);
  const isFlat = meta.layout === "flat";
  const children = navItem.children || [];
  const mobileLinks = isFlat
    ? children
    : groupChildrenByCategory(children).reduce(
        (acc, group) => acc.concat(group.links),
        []
      );

  return (
    <div className="bv-mega-header__mobile-mega">
      <div className="bv-mega-header__mobile-feature">
        <h3 className="bv-mega-header__mobile-feature-title">{meta.title}</h3>
        {meta.description && (
          <p className="bv-mega-header__mobile-feature-description">
            {meta.description}
          </p>
        )}
        <a className="bv-mega-header__mega-cta" href={meta.ctaURL}>
          <span>{meta.ctaText}</span>
          <ArrowUpRightIcon
            className="bv-mega-header__mega-cta-icon"
            size={18}
          />
        </a>
      </div>
      <ul className="bv-mega-header__mega-list bv-mega-header__mega-list--mobile">
        {mobileLinks.map(link => (
          <li key={link.assetID} className="bv-mega-header__mega-list-item">
            <MegaMenuLink href={link.pageURL}>{link.pageName}</MegaMenuLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MegaMenuMobilePanel;
